import { ConfigurationService } from '../shared/services/configuration.service';
import { LookupService } from '../shared/services/lookup.service';
import { UserService } from './user.service';
import { ApplicationStartupService } from './application-startup.service';
import { RouteApplicationStartupResolveService } from './route-application-startup-resolve.service';
import { HrTranslateService } from './hr-translate.service';
import { DefaultApplicationErrorHandlerService } from './default-application-error-handler.service';
import { DefaultAjaxErrorHandlerService } from './default-ajax-error-handler.service';
import { DefaultApiErrorHandlerService } from './default-api-error-handler.service';
import { SmartHttpService } from './smart-http.service';
import { AjaxDataServiceService } from './ajax-data-service.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadIndicatorService } from './load-indicator.service';
import { CustomMessageService } from './message.service';
// import { UrlProviderService } from './url-provider.service';
import { TranslateService } from '@ngx-translate/core';

@NgModule({
  imports: [CommonModule],
  providers: [
    LoadIndicatorService,
    CustomMessageService,
    AjaxDataServiceService,
    SmartHttpService,
    DefaultApiErrorHandlerService,
    DefaultAjaxErrorHandlerService,
    DefaultApplicationErrorHandlerService,
    HrTranslateService,
    TranslateService,
    RouteApplicationStartupResolveService,
    ApplicationStartupService,
    // UserService,
    LookupService,
    ConfigurationService,
  ],
  declarations: [],
})
export class CoreModule {}
